import { useState, useEffect, useCallback } from 'react';
import { logError, logInfo } from '../../../../../utils/logger';

export const useDirections = (map) => {
  const [directionsService, setDirectionsService] = useState(null);
  const [directionsRenderer, setDirectionsRenderer] = useState(null);

  // Initialize directions services
  useEffect(() => {
    if (map) {
      setDirectionsService(new google.maps.DirectionsService());
      const renderer = new google.maps.DirectionsRenderer({
        map,
        suppressMarkers: true,
        polylineOptions: {
          strokeColor: '#0088ff',
          strokeWeight: 4
        }
      });
      setDirectionsRenderer(renderer);
    }
  }, [map]);

  const handleDriveTo = useCallback(async (origin, destination) => {
    if (!map || !directionsService || !directionsRenderer) {
      return;
    }

    try {
      const result = await directionsService.route({
        origin,
        destination,
        travelMode: google.maps.TravelMode.DRIVING
      });

      directionsRenderer.setDirections(result);
      
      // Fit bounds to show the entire route
      const bounds = new google.maps.LatLngBounds();
      bounds.extend(origin);
      bounds.extend(destination);
      map.fitBounds(bounds, {
        padding: { top: 50, right: 50, bottom: 50, left: 50 }
      });

      logInfo('Driving directions set successfully');
    } catch (error) {
      logError('Failed to get directions:', error);
      throw error;
    }
  }, [map, directionsService, directionsRenderer]);

  const clearDirections = useCallback(() => {
    if (directionsRenderer) {
      directionsRenderer.setDirections({ routes: [] });
    }
  }, [directionsRenderer]);

  return {
    directionsService,
    directionsRenderer,
    handleDriveTo,
    clearDirections
  };
};